import { useState } from "react";
import { useTranslation } from "react-i18next";

import { IDE_TYPE } from "../../../../constants/common";
import { useSnack } from "../../../../hooks/useSnack";
import teacherServices from "../../../../services/teacherServices";
import SmoothyCodeEditor from "../../editors/smoothyIDE/SmoothyCodeEditor";
import CodeSolutionsHeader from "../../headings/teacher/smoothy/CodeSolutionsHeader";
import PlaygroundHeader from "../../headings/teacher/smoothy/PlaygroundHeader";
import ShareCodeHeader from "../../headings/teacher/smoothy/ShareCodeHeader";
import SubmissionsHeader from "../../headings/teacher/smoothy/SubmissionsHeader";

const TeacherSmoothyIDEWrapper = ({ type = "playground", onSubmit, ...rest }) => {
  const { t } = useTranslation();

  const [codeData, setCodeData] = useState(null);
  const [projectData, setProjectData] = useState(null);
  const [projectID, setProjectID] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [message, setMessage] = useState("");

  const [smoothy, setSmoothy] = useState("");
  const { showSnack } = useSnack();

  const saveProject = async (payload, isAutoSave) => {
    if (!isAutoSave) setIsSaving(true);

    try {
      let response;
      if (projectData?.id || projectID) {
        // Edit existing project
        response = await teacherServices.editTeacherProjects(projectData?.id || projectID, payload);
      } else {
        // Create new project
        response = await teacherServices.createTeacherProjects(payload);
        setProjectID(response?.project?.id);
      }
      if (isAutoSave) return;

      showSnack(t("saved_successfully"), "success");
    } catch (error) {
      showSnack(error, "error");
    } finally {
      setIsSaving(false);
    }
  };

  const handleSaveProject = async (newProjectName, isAutoSave) => {
    const payload = {
      smoothy: smoothy || "",
      type: IDE_TYPE.SMOOTHY,
      name: newProjectName || projectData?.name,
    };
    saveProject(payload, isAutoSave);
  };

  const handleGetPlaygroundProject = (payload) => {
    setCodeData(payload.code);
    setProjectData(payload.project);
  };

  const handleCreateNewProject = () => {
    setCodeData(null);
    setProjectData(null);
    setProjectID(null);
    setSmoothy("");
  };

  const renderHeader = () => {
    switch (type) {
      case "playground":
        return (
          <PlaygroundHeader
            onGetPlaygroundProject={handleGetPlaygroundProject}
            onCreateNewProject={handleCreateNewProject}
            onSaveProject={handleSaveProject}
            initialProjectName={projectData?.name}
            smoothy={smoothy}
            isSaving={isSaving}
          />
        );
      case "solutions":
        return <CodeSolutionsHeader rest={rest} />;
      case "share":
        return <ShareCodeHeader />;
      case "submissions":
        return <SubmissionsHeader onSubmit={onSubmit} rest={rest} />;
      default:
        return null;
    }
  };

  return (
    <div className="rounded-[12px] bg-blue-100 px-4 py-4 shadow-lg dark:bg-dark-surface">
      {renderHeader()}
      <SmoothyCodeEditor
        isTeacher
        smoothy={smoothy}
        setSmoothy={setSmoothy}
        initialCode={rest?.codeData?.code || codeData}
        setMessage={setMessage}
        message={message}
      />
    </div>
  );
};

export default TeacherSmoothyIDEWrapper;
